import CreateEditProject from "../../views/Project/CreateEditProject";

const CreateEditProjectPage = () => <CreateEditProject />;

export default CreateEditProjectPage;
